
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.7 1.037v-.91h8.422v.91H.7zm0 2.837v-.91h8.422v.91H.7zm10.46-2.837v-.91h8.421v.91H11.16zm0 2.837v-.91h8.421v.91H11.16z","fill":"currentColor"}})])
          )
        }
      }
    